import { Stack } from 'react-bootstrap';

export function NoResultsDisplay(props: { onShowFiltersClick: () => void; show: boolean }) {
    if (!props.show) {
        return null;
    }

    return (
        <div className="text-center p-3">
            <Stack gap={2}>
                <div>No results found that match the current search criteria.</div>
                {props.onShowFiltersClick && (
                    <div>
                        You can{' '}
                        <span className='link cursor-pointer' onClick={props.onShowFiltersClick}>change your filters here.</span>
                    </div>
                )}
            </Stack>
        </div>
    );
}
